/**
 * @generated SignedSource<<b0d4de8754fab13cf9eae743370873aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MeasurementUnit = "CM" | "IN" | "KG" | "LBS" | "PERCENTAGE" | "STEPS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ClientMeasurementsCartDrawerEditView_metrics$data = ReadonlyArray<{
  readonly activityDate: string | null | undefined;
  readonly id: string;
  readonly name: string;
  readonly value: {
    readonly measurement?: number;
    readonly unit?: MeasurementUnit;
  };
  readonly " $fragmentType": "ClientMeasurementsCartDrawerEditView_metrics";
}>;
export type ClientMeasurementsCartDrawerEditView_metrics$key = ReadonlyArray<{
  readonly " $data"?: ClientMeasurementsCartDrawerEditView_metrics$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClientMeasurementsCartDrawerEditView_metrics">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ClientMeasurementsCartDrawerEditView_metrics",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "raw",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "activityDate",
      "storageKey": "activityDate(raw:true)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "measurement",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unit",
              "storageKey": null
            }
          ],
          "type": "CheckinAnswerMeasurementValue",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ClientMetric",
  "abstractKey": null
};

(node as any).hash = "8040e684ebd9bbe9be0385bc753e42e6";

export default node;
